import { RBChannel } from 'store/railsBuilder/reducer.types';

import {
    EpgPartialUpdateActionPayload,
    EpgPartialUpdateSuccessActionPayload,
    EpgSuccessActionPayload,
    GetEpgActionPayload,
    GetEpgByVisibleChannelsActionPayload,
    SetEpgDateActionPayload,
} from './actions.types';
import {
    GET_EPG,
    GET_EPG_BY_VISIBLE_CHANNELS,
    GET_EPG_BY_VISIBLE_CHANNELS_REQUEST,
    GET_EPG_BY_VISIBLE_CHANNELS_SUCCESS,
    GET_EPG_FAILURE,
    GET_EPG_PARTIAL_UPDATE,
    GET_EPG_PARTIAL_UPDATE_FAILURE,
    GET_EPG_PARTIAL_UPDATE_REQUEST,
    GET_EPG_PARTIAL_UPDATE_SUCCESS,
    GET_EPG_REQUEST,
    GET_EPG_SUCCESS,
    SET_EPG_DATE,
    SET_EPG_LAST_UPDATED,
    SET_EPG_REQUEST_IDLE_STATUS,
    SET_EPG_SELECTED_LAYOUT,
    SET_FOCUS_TO_NOW,
    SET_FULLSCREEN,
    SET_PREVIOUSLY_WATCHED_CHANNEL,
    SET_SUBTITLES_DIALOG_VISIBLE,
} from './constants';
import { EpgLayout } from './reducer.types';

export function getEpg(payload: GetEpgActionPayload) {
    return {
        type: GET_EPG,
        payload,
    };
}

export function getEpgByVisibleChannels(
    payload: GetEpgByVisibleChannelsActionPayload,
) {
    return {
        type: GET_EPG_BY_VISIBLE_CHANNELS,
        payload,
    };
}

export function setEpgDate(payload: SetEpgDateActionPayload) {
    return {
        type: SET_EPG_DATE,
        payload,
    };
}

export function getEpgRequest(payload: GetEpgActionPayload) {
    return {
        type: GET_EPG_REQUEST,
        payload,
    };
}

export function setEpgRequestInitialStatus() {
    return {
        type: SET_EPG_REQUEST_IDLE_STATUS,
    };
}

export function getEpgByVisibleChannelsRequest(payload: GetEpgActionPayload) {
    return {
        type: GET_EPG_BY_VISIBLE_CHANNELS_REQUEST,
        payload,
    };
}

export function getEpgSuccess(payload: EpgSuccessActionPayload) {
    return {
        type: GET_EPG_SUCCESS,
        payload,
    };
}

export function getEpgByVisibleChannelsSuccess(
    payload: EpgSuccessActionPayload,
) {
    return {
        type: GET_EPG_BY_VISIBLE_CHANNELS_SUCCESS,
        payload,
    };
}

export function getEpgFailure(error: any) {
    return {
        type: GET_EPG_FAILURE,
        payload: {
            error,
        },
    };
}

export function setFullscreen(fullscreen: boolean) {
    return { type: SET_FULLSCREEN, payload: { fullscreen } };
}

export function setPreviouslyWatchedChannel(payload: {
    channelId: RBChannel['editorial']['id'];
    profileId: string | undefined;
}) {
    return { type: SET_PREVIOUSLY_WATCHED_CHANNEL, payload };
}

export function setSubtitlesDialogVisible(subtitlesDialogVisible: boolean) {
    return {
        type: SET_SUBTITLES_DIALOG_VISIBLE,
        payload: { subtitlesDialogVisible },
    };
}

export function getPartialUpdateEpg(payload: EpgPartialUpdateActionPayload) {
    return {
        type: GET_EPG_PARTIAL_UPDATE,
        payload,
    };
}

export function getPartialUpdateEpgRequest(
    payload: EpgPartialUpdateActionPayload,
) {
    return {
        type: GET_EPG_PARTIAL_UPDATE_REQUEST,
        payload,
    };
}

export function getPartialUpdateEpgSuccess(
    payload: EpgPartialUpdateSuccessActionPayload,
) {
    return {
        type: GET_EPG_PARTIAL_UPDATE_SUCCESS,
        payload,
    };
}

export function getPartialUpdateEpgFailure(error: any) {
    return {
        type: GET_EPG_PARTIAL_UPDATE_FAILURE,
        payload: {
            error,
        },
    };
}

export function setFocusToNow(focusToNow: boolean) {
    return { type: SET_FOCUS_TO_NOW, payload: { focusToNow } };
}

export function setEpgLastUpdated(epgLastUpdated?: number) {
    return { type: SET_EPG_LAST_UPDATED, payload: { epgLastUpdated } };
}

export function setEpgSelectedLayout(epgSelectedLayout?: EpgLayout) {
    return { type: SET_EPG_SELECTED_LAYOUT, payload: { epgSelectedLayout } };
}
